import React, { type PropsWithChildren } from "react";

import { StoreContext } from "@/store/Context";

// Zustand providers
import { MigrateStoreProvider } from "@/features/migrate/state/StoreProvider";
import { ClaimRewardsStoreProvider } from "@/zstnd/providers/claim-rewards-store-provider";

export default function ContextState({ children }: PropsWithChildren) {
  return (
    <StoreContext>
      <ClaimRewardsStoreProvider>
        <MigrateStoreProvider>{children}</MigrateStoreProvider>
      </ClaimRewardsStoreProvider>
    </StoreContext>
  );
}
